// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path')
var _ = require('lodash')
var pkgDeps = require('../package.json').dependencies
var staticPkgs = []
var staticDeps = ['ckeditor']
// ['ckeditor', 'components-jqueryui', 'jquery']

staticDeps.forEach(function (key) {
  if (_.includes(staticDeps, key)) {
    var version = pkgDeps[key]
    staticPkgs.push({
      from: path.resolve(__dirname, '../node_modules/' + key),
      to: 'static/js/' + key + '/' + version + '/'
    })
  }
})

module.exports = {
  title: 'SWARM Smart Reasoning Teams',
  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report,
    staticPkgs: staticPkgs,
    devtool: '#source-map',
    cleanOption: {
      root: path.resolve(__dirname, '..'),
      exclude: [],
      verbose: true,
      dry: false
    },
    pathToClean: ['dist']
  },
  dev: {
    env: require('./dev.env'),
    port: 8888,
    host: 'localhost',   /* '0.0.0.0' for allowing other clients access; 'localhost' for enable notifications; */
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxy: {
      '/api': {
        target:
          process.env.SWARM_API || 'https://swarm-dev.eresearch.unimelb.edu.au',
        secure: false,
        changeOrigin: true,
        cookieDomainRewrite: 'createbetterreasoning.com',
        ws: true,
        logLevel: 'debug',
        proxyTimeout: 60000
      },
      '/http-bind': {
        target:
          process.env.SWARM_API || 'https://swarm-dev.eresearch.unimelb.edu.au',
        secure: false,
        changeOrigin: false,
        ws: true,
        logLevel: 'debug',
        proxyTimeout: 60000
      },
      '/http-ws': {
        target:
          process.env.SWARM_WS_API ||
          'https://swarm-dev.eresearch.unimelb.edu.au',
        secure: false,
        changeOrigin: true,
        ws: true,
        logLevel: 'debug',
        proxyTimeout: 60000
      },
      '/broadcasting-ws': {
        target:
          process.env.SWARM_BROADCASTING_WS_API ||
          'https://swarm-dev.eresearch.unimelb.edu.au',
        secure: false,
        changeOrigin: true,
        ws: true,
        logLevel: 'debug',
        proxyTimeout: 60000
      }
    },
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',
    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,
    cssSourceMap: true
  }
}
